import React, { useContext, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Formik, Field } from "formik";
import { get, isEmpty } from "lodash";
import {
  FieldInput,
  FieldButtonGroup,
  FormLeaveGuard,
  FieldInputNumberAsString,
  FieldInputSSN,
} from "../../../components";
import {
  FLOW_TYPES,
  MANAGE_PLAN_ROUTES,
  getPathWithParam,
  managePlanFormNames,
  formFields,
  yesNoOptions,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  bankAccountNumberNormalizer,
  abaRoutingNumber,
  getFieldsToBeTouched,
} from "../../../utils";
import {
  createPlanStore,
  setManagePlanToastInfo,
  setManagePageLevelData,
  MANAGE_MAPPER_POST_API_ERROR,
} from "../../../contexts";
import { useRouterParams } from "../../../abstracts";
import { saveFunding } from "../../../services";
import { SliderPanel, LoaderWrapper } from "../../../components";
import { useHistory } from "react-router";

const SponsorSlider = ({
  open,
  setOpen,
  outerValues,
  setOuterValues,
  Id,
  fundingId,
  planCashToggle,
  forfeitureToggle,
  achToggle,
}) => {
  const { flow, planId, fundId } = useRouterParams();
  const { dispatch } = useContext(createPlanStore);
  const formName = managePlanFormNames.FUNDING_DETAIL;
  const fields = formFields[formName];
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const formValues = Id ? outerValues?.Data?.find((e) => e.id == Id) : {};
  var initialValues = {
    [fields.bankAccountStatus]: 1,
    [fields.defaultBankAccountIndicator]: isEmpty(outerValues.Data),
    [fields.bankAccountType]: 2,
  };

  const getDataForSave = (values) => {
    let accounts = outerValues?.Data?.filter((x) => x.id != Id);
    return {
      id: fundingId,
      planId: planId,
      planCashAccountEnabled: planCashToggle,
      forfeitureAccountEnabled: forfeitureToggle,
      achAccountEnabled: achToggle,
      sponsorFundingAccounts: [
        ...accounts,
        {
          ...values,
          id: Id ?? 0,
          fundingId: fundingId ?? 0,
          bankAccountNumber: get(values, "bankAccountNumber", "").replace(
            /\s/g,
            ""
          ),
          abaRoutingNumber: get(values, "abaRoutingNumber", "").replace(
            /\s/g,
            ""
          ),
        },
      ],
    };
  };
  const onFormSubmit = (values, { setFieldError, setFieldTouched }) => {
    setLoading(true);
    let errors = {};
    var ans = outerValues?.Data?.find(
      (x) => x.defaultBankAccountIndicator == true
    );
    if (ans && values.defaultBankAccountIndicator === true) {
      errors.defaultBankAccountIndicator =
        "Plan can have only one default account";
      setFieldError(
        fields.defaultBankAccountIndicator,
        "Plan can have only one default account"
      );
      setLoading(false);
    } else
      saveFunding(getDataForSave(values))
        .then((response) => {
          if (response.isSuccessful && Object.keys(errors).length === 0) {
            dispatch(
              setManagePageLevelData({
                formName: formName,
                fieldData: values,
              })
            );
            setOpen(!open);
            dispatch(
              setManagePlanToastInfo({
                showToast: true,
                toastMessage: "Data saved successfully",
              })
            );
            setOuterValues({
              ...outerValues,
              Data: response.funding.sponsorFundingAccounts,
            });
            setLoading(false);
          } else {
            for (var i = 0; i < response.errorMessages?.length; i++) {
              var _ = response.errorMessages[i];
              setFieldTouched(_.controlName, true);
              setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
            }
            setLoading(false);
          }
          setLoading(false);
        })
        .catch((error) => {
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
          // setLoading(false);
        });
  };

  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        values,
        setValues,
        handleChange,
        setFieldValue,
        handleSubmit,
        errors,
      }) => {
        const onCloseHandler = () => {
          if (
            values[fields.bankAccountStatus] !== 1 ||
            values[fields.defaultBankAccountIndicator] !==
              isEmpty(outerValues.Data) ||
            values[fields.bankAccountType] !== 1 ||
            (values[fields.bankAccountName] &&
              (values[fields.bankaccountName] !== null ||
                values[fields.bankAccountName] !== "")) ||
            (values[fields.bankAccountNumber] &&
              (values[fields.bankAccountNumber] !== null ||
                values[fields.bankAccountNumber] !== "")) ||
            (values[fields.abaRoutingNumber] &&
              (values[fields.abaRoutingNumber] !== null ||
                values[fields.abaRoutingNumber] === ""))
          ) {
            setShowModal(true);
          } else {
            handleConfirmClick();
          }
        };

        const handleConfirmClick = () => {
          setShowModal(false);
          setOpen(!open);
          history.push(
            getPathWithParam({
              path: MANAGE_PLAN_ROUTES.MANAGE_FUNDING,
              pathParam: [flow, planId],
            })
          );
        };

        const handleCancelClick = () => {
          setShowModal(false);
        };
        // const defaultInitialValues = isEmpty(outerValues.Data)
        return (
          <SliderPanel
            showBackButton={false}
            isOpen={open}
            showCancelButton={true}
            showSave={true}
            showCancel={false}
            onSave={handleSubmit}
            backdropClicked={() => onCloseHandler()}
            onClose={() => onCloseHandler()}
            showHeader={true}
            // onClose={() => setOpen(!open)}
            header={" Add New Sponsor Bank Account"}
            headerClass={"sponsorAccountHeader"}
            size={38}
            showSeparator={true}
          >
            <Form onSubmit={handleSubmit}>
              <LoaderWrapper isLoading={loading}>
                {/* <ManagePlanLayout
                                // layoutHeader={layoutHeader}
                                //buttons={buttons}
                                pageFlow={newFlow || flow}
                            > */}
                <div style={{ margin: "0px 0px 0px 20px" }}>
                  <Row>
                    <Col>
                      <Field
                        label="Bank Name"
                        name={fields.bankAccountName}
                        type="text"
                        autoComplete="off"
                        value={values[fields.bankAccountName]}
                        onChange={handleChange}
                        component={FieldInput}
                        // disabled={isEdit && !isSave}
                        size="lg"
                        isRequired
                      />
                      <Field
                        label="Bank Account Number"
                        name={fields.bankAccountNumber}
                        type="text"
                        autoComplete="off"
                        value={bankAccountNumberNormalizer(
                          values[fields.bankAccountNumber]
                        )}
                        pattern="[0-9 ]+"
                        onChange={handleChange}
                        isBank={true}
                        component={FieldInputSSN}
                        // disabled={isEdit && !isSave}
                        size="lg"
                        maxLength="14"
                        isRequired
                      />
                      <Field
                        label="ABA Routing Number"
                        name={fields.abaRoutingNumber}
                        type="text"
                        autoComplete="off"
                        value={abaRoutingNumber(
                          values[fields.abaRoutingNumber]
                        )}
                        onChange={handleChange}
                        component={FieldInputNumberAsString}
                        // disabled={isEdit && !isSave}
                        size="lg"
                        maxLength={10}
                        isRequired
                      />
                      <Field
                        label="Bank Account Type"
                        name={fields.bankAccountType}
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.ACCOUNT_TYPE
                        )}
                        selectedValue={values[fields.bankAccountType]}
                        onChange={(value) => {
                          setFieldValue(fields.bankAccountType, value);
                        }}
                        // disabled={isEdit && !isSave}
                        component={FieldButtonGroup}
                        size="smd"
                        isRequired
                      />
                      <Field
                        label="Bank Account Status"
                        name={fields.bankAccountStatus}
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.ACCOUNT_STATUS
                        )}
                        component={FieldButtonGroup}
                        selectedValue={values[fields.bankAccountStatus]}
                        onChange={(value) => {
                          setFieldValue(fields.bankAccountStatus, value);
                        }}
                        // disabled={isEdit && !isSave}
                        size="smd"
                        isRequired
                      />
                      <Field
                        label="Is this the default Bank Account?"
                        name={fields.defaultBankAccountIndicator}
                        options={yesNoOptions}
                        component={FieldButtonGroup}
                        selectedValue={
                          values[fields.defaultBankAccountIndicator]
                        }
                        onChange={(value) => {
                          setFieldValue(
                            fields.defaultBankAccountIndicator,
                            value
                          );
                        }}
                        // disabled={isEdit && !isSave}
                        size="sm"
                        isRequired
                      />
                    </Col>
                  </Row>
                </div>
              </LoaderWrapper>
              {/* </ManagePlanLayout> */}

              <FormLeaveGuard
                showModal={showModal}
                handleConfirmClick={handleConfirmClick}
                handleCancelClick={handleCancelClick}
              />
            </Form>
          </SliderPanel>
        );
      }}
    </Formik>
  );
};

export default SponsorSlider;
